import React from 'react';
import { Navigate, Route } from 'react-router-dom';

// Import client components
import Clients from '../pages/clients/Clients';
import ClientCreateEdit from '../pages/clients/ClientCreateEdit';
import ClientDetail from '../pages/clients/ClientDetail';
import ClientAnalytics from '../pages/clients/ClientAnalytics';

// Import permissions check
import ProtectedRoute from '../components/auth/ProtectedRoute';

const clientRoutes = [
  // Clients list page
  <Route 
    path="clients" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'clients', action: 'read' }}>
        <Clients />
      </ProtectedRoute>
    } 
  />,
  
  // Client create page
  <Route
    path="clients/create"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'clients', action: 'create' }}>
        <ClientCreateEdit />
      </ProtectedRoute>
    }
  />,
  
  // Client edit page
  <Route
    path="clients/:id/edit"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'clients', action: 'update' }}>
        <ClientCreateEdit />
      </ProtectedRoute>
    }
  />,
  
  // Client detail page
  <Route
    path="clients/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'clients', action: 'read' }}>
        <ClientDetail />
      </ProtectedRoute>
    }
  />,
  
  // Client analytics page
  <Route
    path="clients/:id/analytics"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'analytics', action: 'read' }}>
        <ClientAnalytics />
      </ProtectedRoute>
    }
  />,
  
  // Redirect /clients/* to /clients if no match
  <Route path="clients/*" element={<Navigate to="/clients" replace />} />
];

export default clientRoutes;